<template>
  <div class="raw-select">
    <VueMultiselect
      v-model="selectedValue"
      :options="formattedOptions"
      :close-on-select="true"
      :clear-on-select="false"
      :placeholder="d['Salary.Forms.PickOrSearch']?.item2"
      :max-height="600"
      :id="stateKey"
      :allow-empty="false"
      track-by="value"
      :custom-label="customLabel"
    >
    </VueMultiselect>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import { state, localDictionary } from '@/lib/state'

export default {
  components: {
    VueMultiselect,
  },
  emits: ['input-change'],
  props: {
    options: {
      type: Array,
      required: true,
    },
    stateKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      d: localDictionary(),
      state: state,
    }
  },
  computed: {
    formattedOptions() {
      return (
        this.options?.map((option) => ({
          text: option.text || option.workareatext,
          value: option?.id || option?.workareaid,
        })) || []
      )
    },
    selectedValue: {
      get() {
        return (
          this.formattedOptions.find(
            (option) => option.value === this.state.answers[this.stateKey],
          ) || null
        )
      },
      set(value) {
        const selectedOption = this.formattedOptions.find((option) => option.value === value?.value)

        // Store the selected option's value (id) and text
        this.state.answers[this.stateKey] = selectedOption?.value ?? null
        this.state.displayAnswers[this.stateKey] = selectedOption?.text ?? null
        this.$emit('input-change', this.stateKey)
      },
    },
    customLabel() {
      return (option) => option.text
    },
  },
}
</script>

<style lang="postcss">
/* Make sure the dropdown is on top of everything when open */
.multiselect--active .multiselect__content-wrapper,
.multiselect--active .multiselect__input {
  z-index: 2;
  position: relative;
  font-size: var(--font-size-small);
}

.multiselect__placeholder,
.multiselect__single,
.multiselect__input {
  font-size: 14px !important;
}

.raw-select {
  position: relative;
  min-height: 44px;
  width: 99%;
}

.multiselect {
  font-family: var(--font-it-ex);
  font-size: var(--font-size-small);
  letter-spacing: 0.32px;
  margin-top: 10px;
  box-sizing: content-box;
  display: block;
  min-height: 44px;

  @media (min-width: 1024px) {
    position: absolute;
  }

  width: 100%;

  &__content-wrapper {
    overflow: hidden;
    overflow-y: auto;
  }

  &__input {
    margin-bottom: 0 !important;
  }

  &__placeholder,
  &__single {
    border-bottom: 2px solid currentColor;
    display: block;
    line-height: 24px;
    padding: 0 10px 10px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 2rem;
  }

  &__placeholder {
    opacity: 0.5;
  }

  ul {
    list-style: none;
    background: var(--color-grey-4);
    margin: 0;
    padding: 0;
    width: 100%;
    z-index: 3;

    li {
      color: var(--color-black);
      transition: all var(--ani-speed-2) var(--ani-type-1);
      font-weight: var(--font-weight-regular);
      cursor: pointer;
      position: relative;
      overflow: hidden;

      &:before {
        background: currentColor;
        position: absolute;
        height: 1px;
        left: 0;
        right: 0;
        bottom: 1px;
        opacity: 0.5;
        content: '';
      }

      &:after {
        background: currentColor;
        position: absolute;
        height: 2px;
        left: 0;
        right: 0;
        bottom: 1px;
        content: '';
        transform: translateX(-101%);
        transition:
          transform var(--ani-speed-3) var(--ani-type-1),
          -webkit-transform var(--ani-speed-3) var(--ani-type-1);
      }

      /* &:hover {
        &:after {
          transform: translateX(0);
        }
      } */
    }
  }

  &__option {
    width: 100%;
    display: block;
    margin: 0;
    padding: 0;
    padding: 10px 14px;

    &--highlight {
      background: var(--color-grey-3);
    }
  }

  &:after {
    content: '';
    position: absolute;
    width: 24px;
    height: 24px;
    background-image: url("data:image/svg+xml,%3Csvg id='svg-arrow-down-small' width='16' height='10' viewBox='0 0 16 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15 1 L8 8 L1 1' stroke='%23000'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center center;
    top: 6px;
    right: 0;
    transition: all ease 0.2s;
  }

  &--active:after {
    transform: rotate(180deg);
  }
}
</style>
